import { render } from "./ShopperDetails.vue?vue&type=template&id=9204676c&scoped=true"
import script from "./ShopperDetails.vue?vue&type=script&lang=js"
export * from "./ShopperDetails.vue?vue&type=script&lang=js"

import "./ShopperDetails.vue?vue&type=style&index=0&id=9204676c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9204676c"]])

export default __exports__